module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "meu-container"
  }, [_c('div', {
    staticClass: "row margin-bottom-10",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('div', [_c('div', {
    staticClass: "left"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "back-p"
  }, [_vm._v("\n                            " + _vm._s(_vm.$t('loginDescription')) + "\n                        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-container"
  }, [_vm._t("default")], 2)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticClass: "img",
    attrs: {
      "src": require("./logo-NOW_6.png"),
      "alt": "SGS DO BRASIL"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4fcc4d27!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/auth/components/LoginTemplate.vue
// module id = 927
// module chunks = 2